import { BonusType } from '@superbet-group/web.types';

import { Bonus } from '@core/models/bonus/Bonus';
import BonusEligibility from '@core/models/bonus/BonusEligibility';
import { WelcomeBonus } from '@core/models/bonus/WelcomeBonus';

export interface BonusState {
    activeBonuses: Bonus[];
    wagerableBonuses: Bonus[];
    unwagerableBonuses: Bonus[];
    requiredCriteriaBonuses: Bonus[];
    historicBonuses: Bonus[];
    activeBonusEligibility: Nullable<BonusEligibility>;
    welcomeBonuses: WelcomeBonus[];
    areWelcomeBonusesFetched: boolean;
    welcomeOfferCampaignId: string | null;
}

export const sportBonusTypes: Set<BonusType> = new Set([BonusType.Sport, BonusType.Freebet]);
